import { CulminatingCourseCtrl } from './culminating-course.controller';

export const CulminatingCourseStepComponent = {
  controller: CulminatingCourseCtrl,
  bindings: {
    prevStep: '&',
    nextStep: '&',
  },
  template: require('./culminating-course.html'),
};
